<template>
  <div class="o-home-intro">
    <div class="container-xl">
      <div class="row">
        <div
          :class="{ 'col-md-8': banners.length > 0 }"
          class="col"
        >
          <no-ssr>
            <SfHero
              v-if="currentHeroes.length"
              :key="currentSliderId"
              class="hero"
              :slider-options="{
              type: 'carousel',
              animationDuration: 250,
              rewindDuration: 250,
              gap: 24,
              breakpoints: {
                1320: {
                  peek: {
                    before: 0,
                    after: 96
                  }
                },
                1024: {
                  peek: 0
                }
              }
              }"
            >
              <slot>
                <SfHeroItem
                  v-for="(hero, i) in currentHeroes"
                  :key="i"
                  :title="hero.name"
                  :subtitle="hero.caption"
                  :button-text="hero.buttonText"
                  :background="hero.background"
                  :image="getThumbnail('/'+hero.image, 1704, 1080, 'banner')"
                  :class="hero.className"
                  :router-link="hero.click_url"
                />
              </slot>
            </SfHero>
          </no-ssr>
        </div>

        <div
          :class="{ 'col-md-4 desktop-only': heroes.length > 0 }"
          class="col"
          v-if="banners.length > 0"
        >
          <router-link
            v-for="(banner, i) in banners"
            :key="i"
            :to="(banner.click_url) ? banner.click_url : '#'"
          >
            <SfBanner
              :subtitle="banner.caption"
              :title="banner.name"
              description=""
              :button-text="banner.buttonText"
              :image="getThumbnail('/'+banner.image, 828, 1080, 'banner')"
              :class="[banner.className, banner.className ? '' : 'banner-secondary']"
            />
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import {
  SfHero,
  SfBanner
} from '@storefront-ui/vue';
import NoSSR from 'vue-no-ssr';
import { checkWebpSupport } from 'theme/helpers';
import SfHeroItem from 'theme/components/organisms/o-hero-item';

export default {
  name: 'CSectionHomeIntro',
  components: {
    'no-ssr': NoSSR,
    SfHero,
    SfBanner,
    SfHeroItem
  },
  props: {
  },
  data() {
    return {
      windowWidth: null,
      sliderIds: [1, 4]
    };
  },
  mounted() {
    if (window) {
      this.windowWidth = window.innerWidth
      window.addEventListener('resize', this.updateWindowWidth);
    }
  },
  beforeDestroy() {
    if (window) {
      window.removeEventListener('resize', this.updateWindowWidth);
    }
  },
  computed: {
    ...mapState({
      isWebpSupported: false /*state => state.ui.isWebpSupported*/
    }),
    ...mapGetters({
      getBannersBySlider: 'bannerslider/getBannersBySlider'
    }),
    isMobile() {
      return this.windowWidth <= 1023;
    },
    currentSliderId () {
      return this.isMobile ? 4 : 1;
    },
    heroes () {
      return this.sliderIds.reduce((acc, sliderId) => {
        acc[sliderId] = this.getBannersBySlider(sliderId)
        return acc;
      }, {});
    },
    currentHeroes () {
      return this.heroes[this.currentSliderId] || []
    },
    banners () {
      return this.getBannersBySlider(2)
    }
  },
  methods: {
    updateWindowWidth() {
      this.windowWidth = window.innerWidth;
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
